import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./assets/sass/app.scss";
import "materialize-css/sass/materialize.scss";

Vue.config.productionTip = false;
window.baseURL = process.env.NODE_ENV === 'development'? "https://offshore-235606.el.r.appspot.com/api/": "/api/";
window.axios = axios.create({
  baseURL: window.baseURL
});

Vue.prototype.$http = window.axios;
Vue.prototype.$store = store;
Vue.prototype.$vimeobearertoken = "Bearer 8565c566fded54e535f755c9f2ec15db"

new Vue({
  router,
  render: (h) => h(App),
}).$mount("main");
